(function() { window.GUID_7c3a5bbd_7abe_4a29_9615_c9a45631f5dc = { getGuid: function() { return "7c3a5bbd-7abe-4a29-9615-c9a45631f5dc"; } }; })();
var CS;
(function (CS) {
    class DictHelper {
        static ContainsKey(dict, key) {
            return dict.hasOwnProperty(key);
        }
        static Remove(dict, key) {
            var val = dict[key];
            delete dict[key];
            return val;
        }
        static Keys(dict) {
            var keySet = [];
            if (dict == null)
                return keySet;
            for (var prop in dict) {
                if (dict.hasOwnProperty(prop)) {
                    keySet.push(prop);
                }
            }
            return keySet;
        }
        static Values(dict) {
            var values = [];
            for (var prop in dict) {
                if (dict.hasOwnProperty(prop)) {
                    values.push(dict[prop]);
                }
            }
            return values;
        }
        static New() {
            return {};
        }
    }
    CS.DictHelper = DictHelper;
    class Dictionary {
        get Items() { return this.items; }
        constructor(initialsValues) {
            this.items = {};
            this.count = 0;
            if (initialsValues) {
                this.items = initialsValues;
                this.count = this.Keys().length;
            }
            this.raiseDataChanged = {};
            this.DataChanged = new CS.Events.Event("DataChanged", this.raiseDataChanged);
        }
        ContainsKey(key) {
            return this.items.hasOwnProperty(key);
        }
        Count(forceRecount = false) {
            if (forceRecount)
                this.count = this.Keys().length;
            return this.count;
        }
        SetKeyAsUpdated(key) {
            let value = this.Items[key];
            this.raiseDataChanged.raiseEvent({ Action: "change", Dictionary: this, Element: value, Key: key }, this);
        }
        Add(key, value) {
            if (!this.items.hasOwnProperty(key))
                this.count++;
            this.items[key] = value;
            this.raiseDataChanged.raiseEvent({ Action: "add", Dictionary: this, Element: value, Key: key }, this);
        }
        Remove(key) {
            var val = this.Items[key];
            delete this.Items[key];
            this.count--;
            this.raiseDataChanged.raiseEvent({ Action: "remove", Dictionary: this, Element: val, Key: key }, this);
            return val;
        }
        Item(key) {
            return this.Items[key];
        }
        Keys() {
            var keySet = [];
            for (var prop in this.Items) {
                if (this.Items.hasOwnProperty(prop)) {
                    keySet.push(prop);
                }
            }
            return keySet;
        }
        Values() {
            var values = [];
            for (var prop in this.Items) {
                if (this.Items.hasOwnProperty(prop)) {
                    values.push(this.Items[prop]);
                }
            }
            return values;
        }
    }
    CS.Dictionary = Dictionary;
})(CS || (CS = {}));

//# sourceMappingURL=cs-dictionary.js.map
